export default __webpack_public_path__ + "static/media/hero.be354c47.png";